"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.polyfillHistroyVersionsForIOS = exports.polyfillForIOS = exports.isInNative = exports.getOSType = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _consts = require("./consts");

var _urlHelper = _interopRequireDefault(require("../urlHelper"));

var _toast = _interopRequireDefault(require("./toast"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var getQueryString = _urlHelper["default"].getQueryString;

var isInNative = function isInNative() {
  return navigator.userAgent.includes('/shansongclient') || getQueryString('shansongclient') || navigator.userAgent.includes('android_ssy') || getQueryString('android_ssy') || navigator.userAgent.includes('iPhone') || navigator.userAgent.includes('ios_ssy') || getQueryString('ios_ssy');
};

exports.isInNative = isInNative;

var getOSType = function getOSType() {
  var inUA = function inUA(tag) {
    return navigator.userAgent.includes(tag);
  };

  if (inUA('ios_ssy') || inUA('iPhone') || getQueryString('ios_ssy')) {
    return _consts.EOSType.ios;
  }

  if (inUA('android_ssy') || getQueryString('android_ssy')) {
    return _consts.EOSType.android;
  }

  return _consts.EOSType.other;
};

exports.getOSType = getOSType;

var onPageShowAndHideForIos = function onPageShowAndHideForIos() {
  var isPageHide = false;
  window.addEventListener('pageshow', function () {
    if (isPageHide) {
      window.location.reload();
    }
  });
  window.addEventListener('pagehide', function () {
    isPageHide = true;
  });
};

var polyfillHistroyVersionsForIOS = function polyfillHistroyVersionsForIOS() {
  if (getOSType() === _consts.EOSType.ios) {
    onPageShowAndHideForIos();

    if (window.webkit && window.webkit.messageHandlers) {
      window.TitleControlJS = {
        handleTitle: function handleTitle(args) {
          window.webkit.messageHandlers.handleTitle.postMessage(args);
        }
      };
      window.ObtainJsonDataJS = {
        getJsonData: function getJsonData(args) {
          window.webkit.messageHandlers.getJsonData.postMessage(args);
        }
      };
      window.MediaJS = {
        cameraType: function cameraType(args) {
          return window.webkit.messageHandlers.cameraType.postMessage(args);
        },
        chooserType: function chooserType(args) {
          window.webkit.messageHandlers.chooserType.postMessage(args);
        }
      };
      window.lightning = {
        backable: function backable(args) {
          return window.webkit.messageHandlers.backable.postMessage(_objectSpread({}, args));
        }
      };
      window.orderSetting = {
        setDestination: function setDestination(args) {
          return window.webkit.messageHandlers.setDestination.postMessage(_objectSpread({}, args));
        }
      };
      window.RecruitJs = {
        openIndex: function openIndex(args) {
          return window.webkit.messageHandlers.openIndex.postMessage(_objectSpread({}, args));
        },
        recruitFinish: function recruitFinish(args) {
          return window.webkit.messageHandlers.recruitFinish.postMessage(_objectSpread({}, args));
        },
        openRecruitDirectory: function openRecruitDirectory(args) {
          return window.webkit.messageHandlers.openRecruitDirectory.postMessage(_objectSpread({}, args));
        }
      };
      window.ADhandler = {
        receiveData: function receiveData(args) {
          return window.webkit.messageHandlers.receiveData.postMessage(_objectSpread({}, args));
        }
      };
    }
  }
};

exports.polyfillHistroyVersionsForIOS = polyfillHistroyVersionsForIOS;

var polyfillForIOS = function polyfillForIOS(methodName) {
  if (getOSType() === _consts.EOSType.ios) {
    if (window.webkit && window.webkit.messageHandlers) {
      if (!window.IssJsBridgeCourier) {
        window.IssJsBridgeCourier = {};
      }

      window.IssJsBridgeCourier[methodName] = function () {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return window.webkit.messageHandlers[methodName].postMessage(args);
      };

      return window.IssJsBridgeCourier;
    } else {
      (0, _toast["default"])('ios jsBridge 注入失败');
    }
  } else {
    console.log(window.IssJsBridgeCourier, 'window.IssJsBridgeCourier');
    return window.IssJsBridgeCourier;
  }
};

exports.polyfillForIOS = polyfillForIOS;